import { slideToggle } from './helpers';

class CheckboxSelect {
	constructor(el) {
		if (el) {
			this.el = el;
			this.title = this.el.querySelector('.checkbox-select__title');
			this.options = this.el.querySelector('.checkbox-select__options');

			this.el.addEventListener('focusin', this.open);
			this.el.addEventListener('click', this.handleInnerClicks);
			document.addEventListener('click', this.handleOuterClicks);
		}
	}

	open = () => {
		if (!this.isActive()) {
			this.closeActive();
			slideToggle(this.options);
			this.el.classList.add('active');
		}
	}

	close = () => {
		if (this.isActive()) {
			slideToggle(this.options);
			this.el.classList.remove('active');
		}
	}

	closeActive = () => {
		const activeSelect = document.querySelector('.checkbox-select.active');
		if (activeSelect) {
			const activeOptions = activeSelect.querySelector('.checkbox-select__options');
			if (activeOptions) {
				slideToggle(activeOptions);
				activeSelect.classList.remove('active');
			}
		}
	}

	handleInnerClicks = (e) => {
		if (this.isActive()) {
			const { target } = e;
			const targetTitle = target.closest('.checkbox-select__title');
			if (targetTitle === this.title) {
				this.close();
			}
		} else {
			this.open();
		}
	}

	handleOuterClicks = (e) => {
		if (this.isActive()) {
			const { target } = e;
			const targetSelect = target.closest('.checkbox-select');
			if (targetSelect !== this.el) {
				this.close();
			}
		}
	}

	isActive = () => this.el.classList.contains('active')
}

const checkboxSelectEls = [...document.querySelectorAll('.checkbox-select')];
if (checkboxSelectEls.length) {
	checkboxSelectEls.map((el) => new CheckboxSelect(el));
}
